import { Component } from '@angular/core'

@Component({
    selector: 'ElectronicSOALayout',
    template: `
      <router-outlet></router-outlet>
  `
})

export class ElectronicSOALayoutComponent { }
